import { render, staticRenderFns } from "./RemoteCreate.vue?vue&type=template&id=2132b59a&scoped=true&"
import script from "./RemoteCreate.vue?vue&type=script&lang=js&"
export * from "./RemoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132b59a",
  null
  
)

export default component.exports